if (!customElements.get('mobile-sticky-product-form')) {
  customElements.define(
    'mobile-sticky-product-form',
    class MobileStickyProductForm extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = this.closest('product-info');
        this.productFormElement = this.closest('product-form');
        this.primaryButton = this.productInfo?.querySelector(`#ProductSubmitButton-${this.sectionId}`);
        this.primaryPurchaseArea = this.primaryButton?.closest('[data-dt-primary-purchase-area]');
        this.priceSource = this.productInfo?.querySelector(`#price-${this.sectionId}`);
        this.stickyButton = this.querySelector('[data-dt-sticky-submit]');
        this.stickyButtonText = this.stickyButton?.querySelector('span');
        this.stickyPrice = this.querySelector('[data-dt-sticky-price]');
        this.mobileMedia = window.matchMedia('(max-width: 749px)');
        this.primaryPurchasePassed = false;

        if (!this.productFormElement || !this.primaryButton || !this.primaryPurchaseArea || !this.stickyButton) return;

        this.handleStickySubmit = (event) => {
          if (this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true') return;
          this.productFormElement.onSubmitHandler(event);
        };
        this.handleMediaChange = () => this.updateVisibility();
        this.handleDisclosureToggle = (event) => {
          const summary = event.currentTarget.querySelector('summary');
          summary?.setAttribute('aria-expanded', event.currentTarget.open ? 'true' : 'false');
        };
        this.handleDisclosureKeydown = (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.giftDisclosure.open = !this.giftDisclosure.open;
        };

        this.stickyButton.addEventListener('click', this.handleStickySubmit);
        this.mobileMedia.addEventListener('change', this.handleMediaChange);

        this.giftDisclosure = this.productInfo.querySelector('.dt-product-gift-message');
        this.giftDisclosure?.addEventListener('toggle', this.handleDisclosureToggle);
        this.giftDisclosure?.querySelector('summary')?.addEventListener('keydown', this.handleDisclosureKeydown);

        this.stateObserver = new MutationObserver(() => this.syncState());
        this.stateObserver.observe(this.primaryButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (this.priceSource) {
          this.stateObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }

        this.bodyObserver = new MutationObserver(() => this.updateVisibility());
        this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        this.intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            const usefulViewportTop = entry.rootBounds?.top ?? 0;
            this.primaryPurchasePassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= usefulViewportTop;
            this.updateVisibility();
          },
          { rootMargin: '-72px 0px 100000px 0px', threshold: 0 }
        );
        this.intersectionObserver.observe(this.primaryPurchaseArea);

        this.syncState();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleStickySubmit);
        this.mobileMedia?.removeEventListener('change', this.handleMediaChange);
        this.giftDisclosure?.removeEventListener('toggle', this.handleDisclosureToggle);
        this.giftDisclosure?.querySelector('summary')?.removeEventListener('keydown', this.handleDisclosureKeydown);
        this.stateObserver?.disconnect();
        this.bodyObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      syncState() {
        const primaryText = this.primaryButton.querySelector(':scope > span')?.textContent.trim();
        const currentPrice = this.priceSource?.querySelector(
          '.price__sale .price-item--sale, .price__regular span.price-item--regular'
        );
        const disabled =
          this.primaryButton.disabled ||
          this.primaryButton.getAttribute('aria-disabled') === 'true' ||
          this.primaryButton.classList.contains('loading');

        if (primaryText) this.stickyButtonText.textContent = primaryText;
        if (currentPrice?.textContent.trim()) this.stickyPrice.textContent = currentPrice.textContent.trim();

        this.stickyButton.disabled = disabled;
        this.stickyButton.toggleAttribute('aria-busy', this.primaryButton.classList.contains('loading'));
      }

      updateVisibility() {
        const modalOpen =
          document.body.classList.contains('overflow-hidden') ||
          document.body.classList.contains('overflow-hidden-mobile') ||
          document.querySelector('cart-drawer.active');
        const visible = this.mobileMedia.matches && this.primaryPurchasePassed && !modalOpen;

        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
    }
  );
}
